const updates = [
  { time: '07-30 14:22', tag: '最新爆料', title: '某知名网红直播间失言事件完整版流出，粉丝集体脱粉回踩', hot: true },
  { time: '07-30 11:08', tag: '独家首发', title: '顶流艺人深夜私会神秘女子被拍，工作室紧急公关删帖', hot: true },
  { time: '07-30 09:45', tag: '热门追踪', title: '综艺节目录制现场争执画面曝光，导演组紧急叫停录制', hot: false },
  { time: '07-29 22:30', tag: '深度扒皮', title: '某品牌代言人合约纠纷内幕，千万违约金背后的资本博弈', hot: true },
  { time: '07-29 18:15', tag: '最新爆料', title: '选秀节目选手黑历史被扒，参赛资格引发观众广泛质疑', hot: false },
  { time: '07-29 15:40', tag: '独家首发', title: '知名博主被曝抄袭国外内容，粉丝数一夜骤降数十万', hot: true },
  { time: '07-29 10:20', tag: '热门追踪', title: '娱乐圈又一对明星夫妇被传婚变，社交账号互相取关', hot: false },
  { time: '07-28 21:05', tag: '深度扒皮', title: '短视频平台头部主播涉嫌虚假宣传，消费者集体维权进展', hot: true },
  { time: '07-28 16:33', tag: '最新爆料', title: '某网剧剧组拍摄期间发生严重事故，多位演员受伤送医', hot: false },
];

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            实时追踪全网最新黑料动态，第一时间掌握吃瓜资讯
          </p>
        </div>

        <div className="relative pl-8 md:pl-10">
          <div className="absolute left-3 md:left-4 top-2 bottom-2 w-px bg-background-300/60"></div>

          <div className="flex flex-col gap-5">
            {updates.map((item, i) => (
              <div key={i} className="relative group">
                <div className={`absolute left-[-1.35rem] md:left-[-1.65rem] top-2 w-3 h-3 rounded-full border-2 ${
                  item.hot
                    ? 'bg-primary-500 border-primary-500'
                    : 'bg-white border-background-300'
                }`}></div>

                <div className="bg-white rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className={`px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${
                      item.tag === '独家首发'
                        ? 'bg-accent-100 text-accent-700'
                        : item.tag === '深度扒皮'
                        ? 'bg-secondary-100 text-secondary-700'
                        : 'bg-primary-50 text-primary-600'
                    }`}>
                      {item.tag}
                    </span>
                    {item.hot && (
                      <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-primary-500 text-white whitespace-nowrap">
                        HOT
                      </span>
                    )}
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}